export const menus = [
  {
    title: 'プレイヤー',
    href: '/web/school-admin/players',
  },
  {
    title: '教師',
    href: '/web/school-admin/teachers',
  },
  {
    title: 'グループ',
    href: '/web/school-admin/groups',
  },
  {
    title: 'コンテンツ',
    href: '/web/school-admin/contents',
  },
  {
    title: 'スクール',
    href: '/web/school-admin/school-detail',
  },
]
